import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { combineLatest, filter, map, Observable, take } from 'rxjs';

import { environment } from '../../../environments/environment';
import { SecurityProfileQuery } from '../../loan-state';
import { ApiAppSettingsStore } from '../state/api-app-settings.store';
import { ApiAppSettingsModel } from '../models/app-settings/api-app-settings.model';
import { ApiAppSettingQuery } from '../state/api-app-settings.query';

// Related to CLEAR2 DB Table [ApiAppSetting]
@Injectable({
  providedIn: 'root',
})
export class AppSettingsService {
  private readonly _apiAppSettingQuery = inject(ApiAppSettingQuery);
  private readonly _apiAppSettingStore = inject(ApiAppSettingsStore);
  private readonly _http = inject(HttpClient);
  private readonly _securityProfileQuery = inject(SecurityProfileQuery);

  isSelfDisclosureFullAccess$: Observable<boolean> = combineLatest({
    securityProfile: this._securityProfileQuery.selectActive().pipe(filter((t) => !!t)),
    fullAccessIds: this._apiAppSettingQuery.getSelfDisclosureFullAccessIds$,
  }).pipe(map(({ securityProfile, fullAccessIds }) => !!fullAccessIds.find((allowedId) => allowedId === securityProfile.securityProfileId)));

  isShowSandboxLoanLpa$: Observable<boolean> = this._apiAppSettingQuery.getSandboxLoanLpa$;

  getApiAppSettings(): void {
    const url = `${environment.retail.apiUrl}/apiappsettings`;
    this._http
      .get<ApiAppSettingsModel[]>(url)
      .pipe(take(1))
      .subscribe((settings: ApiAppSettingsModel[]) => {
        this._apiAppSettingStore.set(settings);
      });
  }

  getApiAppSettingByName$(name: string): Observable<any> {
    return this._apiAppSettingQuery.getAppSettingByName$(name);
  }
}
